import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';

const columns = [
  {
    title: 'Sales Team',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/sales/teams/'+record.seo}>
        EDIT
      </Link>
    )
  }
]



const SalesTeams = () => {
  const salesTeams = useLoaderData();
  const navigate = useNavigate();

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/sales/teams/'+record.seo)
    };
  }


  
  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Sales Teams</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/sales/teams/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        sticky
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={salesTeams}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'number'}
      />
    
    </div>
  )
}

export default SalesTeams;